import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { Attachment, ATTACHMENT_STATE, SourceType } from '@@api/services/attachments/schemas';
import config from '@@config';

export const attachmentsService = defineService(
    (defineEndpoint) => ({
        attachments: {
            delete: defineEndpoint({
                method: 'DELETE',
                path: '/attachments/:id',
                pathParams: z.object({
                    id: Attachment.shape.id,
                }),
                responses: {
                    204: z.string().optional(),
                },
            }),
            patch: defineEndpoint({
                method: 'PATCH',
                path: '/attachments/:id',
                pathParams: z.object({
                    id: Attachment.shape.id,
                }),
                body: z.object({
                    state: z.nativeEnum(ATTACHMENT_STATE),
                }),
                responses: {
                    200: Attachment,
                },
            }),
            post: defineEndpoint({
                method: 'POST',
                path: '/attachments/:microservice/:resource/:id',
                pathParams: z.object({
                    microservice: z.string(),
                    resource: z.string(),
                    id: z.string().uuid(),
                }),
                body: z.object({
                    sourceId: z.string(),
                    sourceType: SourceType,
                    state: z.enum([ATTACHMENT_STATE.USED, ATTACHMENT_STATE.UNUSED]),
                }),
                responses: {
                    201: Attachment,
                },
            }),
            getAll: defineEndpoint({
                method: 'GET',
                path: '/attachments/:microservice/:resource/:id',
                pathParams: z.object({
                    microservice: z.string(),
                    resource: z.string(),
                    id: z.string().uuid(),
                }),
                responses: {
                    200: z.array(Attachment),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.attachmentsUrl,
    },
);
